/** @format */

import { useForm } from "react-hook-form";
import Tq5Mapper from "../mappers/tq5Mapper";
import { handleNext } from "../../../shared/utils/navigationUtils";
import QuoteFormWrapper from "../../../shared/components/quoteFormWrapper";
import FormNavigationButtons from "../../../shared/components/FormNavigationButtons";
import QuoteStep from "../enums/QuoteStep";
import useAppStateStore from "../../../shared/store/AppStateStore";
import { HotjarEventNames } from "../../../shared/utils/hotjarEventNames";
import { TrackHotjarEvent } from "../../../shared/utils/trackHotjarEvent";
import { useState } from "react";
import VehicleLookup from "../../../shared/components/VehicleLookup/VehicleLookup";
import ukRegistrationValidation from "../../../shared/utils/ukRegistrationValidation";
import FieldStack from "../../../shared/components/FieldStack";
import QuoteStepHeading from "../../../shared/components/QuoteStepHeading";

const Tq5 = () => {
  const [errorVR, setErrorVR] = useState(null);

  const formMethods = useForm({
    defaultValues: Tq5Mapper.get(),
  });
  const {
    formState: { isValid },
    watch,
    handleSubmit,
  } = formMethods;

  const STATE = useAppStateStore();

  const onSubmit = (data) => {
    if (isValid) {
      TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_TQ5_NEXT_CLICKED);
    }
    if (!STATE.showExtraLookupQuestions) {
      setErrorVR("Please complete the vehicle lookup process");
      return;
    }
    Tq5Mapper.set(data, STATE);
    handleNext(QuoteStep.TQ6);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <QuoteFormWrapper>
        <QuoteStepHeading
          title="Vehicle Details"
          description="We're almost there. Just a few more details to complete your quote."
        />
        <FieldStack>
          <VehicleLookup
            STATE={STATE}
            formMethods={formMethods}
            errorVR={errorVR}
            setErrorVR={setErrorVR}
            showRegistrationUnknownToggle={false}
            registrationValidation={ukRegistrationValidation}
          />
        </FieldStack>
      </QuoteFormWrapper>
      <FormNavigationButtons
        prevStep={QuoteStep.TQ4}
        isValid={
          (STATE.isManualVehicleEntry
            ? isValid && watch("setSelectedVehicleIndex") !== null
            : isValid) &&
          watch("make") !== null &&
          watch("model") !== null &&
          STATE.showExtraLookupQuestions
        }
      />
    </form>
  );
};

export default Tq5;
